export default __webpack_public_path__ + "static/media/start.3d61d51e.jpg";